module.exports = __webpack_public_path__ + "img/toolsItem08.681ffa1a.png";